import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import PublicSurveyApp from '../survey-public/PublicSurveyApp';

const SurveyPublic = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path='/survey/:token'>
          <PublicSurveyApp />
        </Route>
        <Route path='/survey/:token/:any'>
          <PublicSurveyApp />
        </Route>
        <Route>
          <Redirect to='/' />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default SurveyPublic;
